import { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BaseProvider } from '@telus-uds/components-web';

import PaymentForm from './pages/link-form/LinkFormPage';
import StatusPage from './pages/status/StatusPage';
import { useTheme } from './BrandThemeProvider';

import '@telus-uds/palette-allium/build/web/fonts/fonts-cdn.css';
import '@telus-uds/palette-koodo/build/web/fonts/fonts-cdn.css';
import '@telus-uds/palette-public-mobile/build/web/fonts/fonts-cdn.css';
import './App.css';

export default function App() {
  const { t } = useTranslation();
  const { currentTheme, currentBrand } = useTheme();

  const setFavicon = (url) => {
    const link = document.querySelector("link[rel~='icon']");
    if (!link) {
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = url;
      document.head.appendChild(newLink);
    } else {
      link.href = url;
    }
  };

  // Set the favicon and title based on the brand
  useEffect(() => {
    setFavicon(`/favicons/${currentBrand}.png`);
    document.title = `${t('Payment Portal')} - ${currentBrand}`;
  }, [currentBrand]);

  return (
    <BaseProvider defaultTheme={currentTheme}>
      <Router>
        <Routes>
          <Route path="/:linkToken" element={<PaymentForm />} />
          <Route path="/status" element={<StatusPage />} />
          <Route path="/error" element={<StatusPage />} />
        </Routes>
      </Router>
    </BaseProvider>
  );
}
